import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Flex } from '@mafc/trolly';
import { IAppState } from '@mafc/common';
import Card from '../Card';

import * as S from './DriverTips.style';
import useDrawerControls from 'hooks/useDrawerControls';
import TrackerCheckout from 'utils/Tracker.checkout';
import DriverTipDrawer from '../DriverTipDrawer';

const TipButton: React.FC<{
  tip: number;
  selectedTip: number;
  onClick: (tip: number) => void;
}> = ({ tip, selectedTip, onClick }) => {
  const currency = useSelector((state: IAppState) => state.appConfig.currencyCodeLocalized);
  const id = `tip-btn-${tip}`;

  const onClickHandler = () => onClick(tip);

  return (
    <S.TipButtonWrapper>
      <S.Radio type="radio" id={id} name="driver-tip" value={tip} checked={selectedTip === tip} />
      <S.TipButton
        htmlFor={id}
        data-testid={id}
        onClick={onClickHandler}
      >{`${currency} ${tip}`}</S.TipButton>
    </S.TipButtonWrapper>
  );
};

const DriverTips: React.FC<{
  tips: number[];
}> = ({ tips }) => {
  const { isOpen, openDrawer, closeDrawer } = useDrawerControls();
  const [isShown, setShown] = useState(false);
  const [selectedTip, setTip] = useState(-1);

  const { t } = useTranslation();

  const onTipClick = (tip: number) => {
    openDrawer();
    setTip(tip);
    TrackerCheckout.driverTipClicked(tip);
  };

  const closeDrawerHandler = () => {
    closeDrawer();
    setShown(true);
  };

  return (
    <S.DriverTips>
      <Card.Title mb={3}>{t('driverTips.heading')}</Card.Title>

      {isShown ? (
        <S.ComingSoon>{t('driverTips.comingSoon')}</S.ComingSoon>
      ) : (
        <Flex testId="driver-tips">
          {tips.map(tip => (
            <TipButton key={tip} tip={tip} onClick={onTipClick} selectedTip={selectedTip} />
          ))}
        </Flex>
      )}

      {isOpen && <DriverTipDrawer isOpen closeDrawer={closeDrawerHandler} />}
    </S.DriverTips>
  );
};

export default DriverTips;
